import * as React from "react";
import { useEffect, useRef } from "react";
import Datepickk from "datepickk";
import { getStrings } from "../../Shared/Reservation/StringResources";
import dayjs from "dayjs";
import SvgCalendar from "../../Shared/Icons/Calendar";
import { ICalendarDay } from "../Models";


const strings = getStrings().component.dateSelector;
const maxDate = dayjs().add(500, "days").toDate();

// const datepickers = new Map<string, Datepickk>();

export interface IDateSelectorProps {
	selectedDate?: string;
	minDate?: string;
	id?: string;
	departureCalendar?: { [key: string]: ICalendarDay },
	onDateSelected: (date: string) => void;
	onNavigation?: (currentDate: string) => void;
};

export const DateSelector = (props: IDateSelectorProps) => {
	//const [datepicker, setDatePicker] = useState<Datepickk>();
	const date = (props.selectedDate ? dayjs(props.selectedDate) : dayjs()).startOf("day");
	const minDate = (props.minDate ? dayjs(props.minDate) : dayjs()).startOf("day");

	const pickerRef = useRef<Datepickk>();

	let container: HTMLElement | null;

	//För att det ska gå att komma åt kalendern i onNavigation
	// const calendarRef = useRef(props.departureCalendar);
	// calendarRef.current = props.departureCalendar;

	function setupPicker() {
		//let picker = datepickers[props.id];
		let picker = pickerRef.current;

		if (!picker) {
			picker = new Datepickk();
			//Varför? (window as any).picker = picker;
			picker.maxSelections = 1;
			picker.maxDate = maxDate;
			picker.lang = document?.documentElement?.lang.indexOf("sv") >= 0 ? "se" : "en";
			picker.onSelect = dateSelected;
			picker.container = container;
			picker.inline = true;
			picker.onNavigation = () => onNavigation(picker.currentDate)

			setPickerHighlights(picker);
			pickerRef.current = picker;
		}

		picker.minDate = minDate.toDate();
		picker.startDate = date.toDate();
		picker.unselectAll(true);
		if (date)
			picker.selectDate(date.toDate(), true);

		if (!picker.isOpen)
			picker.show();

		return picker;
	}

	function setPickerHighlights(picker?: Datepickk) {
		if (!picker)
			picker = pickerRef.current;
			//picker = datepickers[props.id];

		if (!picker)
			return;

		picker.highlight = null; //Rensa tidigare highlights
		if (props.departureCalendar) {
			const daysWithTraffic = Object.getOwnPropertyNames(props.departureCalendar).map(x => ({ start: dayjs(x).toDate(), end: dayjs(x).toDate() }));
			const highlights = [{
				dates: daysWithTraffic,
				backgroundColor: "#ffff88",
				legend: strings.hasTraffic
			}];

			picker.highlight = highlights;
		}
	}

	function onNavigation(currentDate: Date) {
		if (!props.onNavigation)
			return;

		props.onNavigation(dayjs(currentDate).format("YYYY-MM-DD"));
	}

	function dateSelected(this: Date, checked: boolean)
	{
		const selectedDate = this;
		// console.debug("Date selected", selectedDate, checked);

		if (checked) {
			const m = dayjs(selectedDate);
			props.onDateSelected(m.format("YYYY-MM-DD"));
		}
	}

	// useEffect( () => () => console.log("unmount"), [] );

	useEffect(() => {
		// console.debug("props changed", props);
		setupPicker();
	}, [props.id, props.selectedDate, props.minDate]);

	// useEffect(() => {
	// 	//Städa bort pickern när komponenten avmonteras
	// 	return () => {
	// 		datepickers[props.id] = undefined;
	// 	}
	// }, []);


	useEffect(() => {
		// console.debug("DepartureCalendar changed", props.departureCalendar);
		setPickerHighlights();
	}, [props.departureCalendar]);

	return (
		<div className="date-selector">
			<div className="selected-date">
				<SvgCalendar /> <span>{date?.format("dddd LL") || strings.selectDate}</span>
			</div>
			<div ref={el => container = el}></div>
		</div>
	);

};